import { render } from "./LabelInput.vue?vue&type=template&id=959d8666"
import script from "./LabelInput.vue?vue&type=script&lang=js"
export * from "./LabelInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__